// GIF search (the sticker panel's GIF tab): through our server (Tenor or
// Giphy), sent as a looping silent MP4, end-to-end encrypted like a video.
import { useEffect, useLayoutEffect, useRef, useState } from "preact/hooks";
import { api } from "../api";
import { prepareFile } from "../media";
import { engine, toast } from "./Main";

type Gif = { id: string; title?: string; preview: string; url: string; width: number; height: number };

export async function sendGif(jid: string, g: Gif) {
  const blob = await (await fetch(g.url)).blob();
  const p = await prepareFile(new File([blob], "gif.mp4", { type: blob.type || "video/mp4" }));
  await engine.value?.sendDraft(jid, { body: "", kind: "video", media: { ...p.media, gif: true, name: undefined } });
}

export function GifPanel({ jid, onSent }: { jid: string; onSent: () => void }) {
  const [q, setQ] = useState("");
  const [gifs, setGifs] = useState<Gif[] | null>(null);
  const [next, setNext] = useState("");
  const [error, setError] = useState("");
  const input = useRef<HTMLInputElement>(null);
  useLayoutEffect(() => input.current?.focus(), []);
  useEffect(() => {
    let live = true;
    const t = setTimeout(
      () =>
        void api.gifs(q).then(
          (r) => live && (setGifs(r.gifs), setNext(r.next), setError("")),
          (e) => live && setError((e as Error).message),
        ),
      q ? 300 : 0,
    );
    return () => ((live = false), clearTimeout(t));
  }, [q]);
  const more = () => void api.gifs(q, next).then((r) => (setGifs((g) => [...(g ?? []), ...r.gifs]), setNext(r.next)));
  return (
    <div class="gif-panel">
      <input ref={input} class="line-input" value={q} placeholder="Search GIFs" aria-label="Search GIFs" onInput={(e) => setQ(e.currentTarget.value)} />
      {error && <p class="error pad">{error}</p>}
      {!gifs && !error && <p class="muted pad">Loading…</p>}
      <div class="gif-grid">
        {gifs?.map((g) => (
          <button
            key={g.id}
            class="gif-cell"
            aria-label={`Send GIF ${g.title ?? ""}`.trim()}
            title={g.title}
            onClick={() => {
              onSent();
              void sendGif(jid, g).catch((e) => toast("Couldn't send the GIF: " + (e as Error).message));
            }}
          >
            <img src={g.preview} alt={g.title ?? "GIF"} loading="lazy" />
          </button>
        ))}
      </div>
      {next && gifs && gifs.length > 0 && (
        <button class="link pad" onClick={more}>
          More GIFs
        </button>
      )}
    </div>
  );
}
